import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import DashboardModal from "@/components/modals/DashboardModal";
import Spinner from "@/components/Spinner";
import ShieldIcon from "@/assets/icon/ShieldIcon";
import { deleteEventDayTaskRequest } from "@/axios/delete-request";
import { useEvent } from "@/hooks/useEvent";
import useActivityLog from "@/hooks/useActivityLog";

interface Props {
    onClose: () => void;
    eventDayTaskId: string;
    eventDayTaskName: string;
}

export default function DeleteEventTaskModal({ eventDayTaskId, eventDayTaskName, onClose }: Props) {
    const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();
    const { activeCeremonyId, selectedEventId } = useEvent();
    const { deleteEventTaskAuditRequest } = useActivityLog();

    async function deleteEventTaskHandler() {
        try {
            if (!eventDayTaskId) {
                return toast.error("Event day task id is required");
            }
            setLoading(true);
            const deleteChecklistResponse = await deleteEventDayTaskRequest(eventDayTaskId, selectedEventId, activeCeremonyId);
            if (!deleteChecklistResponse.data.status) {
                setLoading(false);
                return toast.error("Oops unable to delete checklist");
            }
            setLoading(false);
            await deleteEventTaskAuditRequest(eventDayTaskName);
            queryClient.invalidateQueries({ queryKey: [`ceremony_${activeCeremonyId}_${selectedEventId}`] });
            return onClose();
        } catch (error) {
            setLoading(false);
            console.log("error", error);
        }
    }

    return (
        <DashboardModal title="Delete Event day task" onClose={onClose} className="small_width delete_modal_view delete_user_event_modal">
            <section className="delete_category_cost_item">
                <div className="icon_wrapper">
                    <ShieldIcon />
                </div>
                <h4>Are you sure you want to delete {eventDayTaskName}&#39;s event day task?</h4>

                <button onClick={deleteEventTaskHandler} disabled={loading}>
                    Delete
                    {loading && <Spinner className="ml-2" size={20} />}
                </button>
            </section>
        </DashboardModal>
    );
}
